import React from "react";
import { Form, Row } from "react-bootstrap";

import { Field } from "../../utils/components/form";
import NATIONS from "../../data/nations.json";
import { capitalize } from "../../utils/functions";
import { InputError } from "./InputError";

export const InputNationalitaet = (props = {}) => {
  const {
    name, className, validate, placeholder, label, beschreibung, labelClass, inputClass, required, testId, ...attributes
  } = props;

  const ensureDigits = (number) => {
    let newNumber = "00" + number;
    newNumber = newNumber.substring(newNumber.length - 3);
    return newNumber;
  };

  let nations = NATIONS.laenderuebersicht;
  if (!Array.isArray(nations))
    nations = [];
  //elimante elements with null values
  const laenderuebersicht = nations
    .filter(n => n.Langbezeichung !== "<NULL>" && n["National-Kennzeichen"] !== "<NULL>" && n["Langbezeichnung (englisch)"] !== "<NULL>")
    .sort(function (a, b) {
      if (a.Langbezeichnung < b.Langbezeichnung) { return -1; }
      if (a.Langbezeichnung > b.Langbezeichnung) { return 1; }
      return 0;
    })
    .map(nation => {
      return {
        key: ensureDigits(nation["Nationalität"]),
        Langbezeichnung: capitalize(nation.Langbezeichnung)
      };
    });

  const requiredStar = required ? "*" : "";
  return (
    <Form.Group as={Row} className="pb-1" >
      <Form.Label className={labelClass}>
        <span className="fs-4 pe-2">{label}{requiredStar}</span>
        <span>{beschreibung}</span>
      </Form.Label>
      <Field
        name={name}
        className={className}
        validate={validate}
        {...attributes}
      >
        {({ input, meta }) => {
          return (
            <>
              <Form.Group className={inputClass + (meta && meta.touched && meta.error ? " is-invalid" : "")}>
                <Form.Select
                  {...input}
                  aria-label={label}
                  size="lg"
                  required={required}
                  isInvalid={meta && meta.touched && meta.error}
                  isValid={meta && meta.touched && !meta.error}
                  data-testid={testId}
                >
                  <option value="">{label} auswählen...</option>
                  {laenderuebersicht.map((nation) => <option key={`L${nation.key}`} value={nation.key}>
                    {nation.Langbezeichnung}
                  </option>
                  )}
                </Form.Select>
              </Form.Group>
              <InputError meta={meta} />
            </>
          );
        }}
      </Field>
    </Form.Group>
  );
};
